// extracted by mini-css-extract-plugin
module.exports = {"col":"CollectionList_col__1TQVP"};